<template>
  <div
    class="page--employee"
    :style="`min-height: ${height}px`"
  >
    <Header
      :kind="routeParams.type"
      :status="currentStatus"
      @bulkImport="$router.push({ name: 'EmployeeBulkOperation' })"
    />

    <Form
      :kind="routeParams.type"
      :submit="submitForm"
      :data="employeeData"
      :status="currentStatus"
      @tryAgain="getEmployeeById"
      @setCurrentStatus="setCurrentStatus"
    />

    <Footer
      v-if="hasRole('employee', 'ROLE_POST_EMPLOYEE') || hasRole('employee', 'ROLE_PUT_EMPLOYEE_ID')"
      :kind="routeParams.type"
      :status="currentStatus"
      @submit="handleSubmit"
    />
  </div>
</template>

<script>
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { hasRole } from 'utils/functions'
import { mapActions } from 'vuex'
import moment from 'moment'
import Header from 'components/employee/Header'
import Form from 'components/employee/Form'
import Footer from 'components/employee/Footer'

export default {
  name: 'EmployeePage',
  components: {
    Header,
    Form,
    Footer
  },
  computed: {
    routeParams () {
      return this.$route.params
    },

    height () {
      return document.body.offsetHeight
    }
  },
  data () {
    return {
      namespace: 'Views.EmployeePage',
      submitForm: false,
      employeeData: null,
      currentStatus: null
    }
  },
  methods: {
    ...mapActions({
      errorAlert: 'snackbarAlert/error'
    }),

    hasRole (group, role) {
      return hasRole(group, role)
    },

    handleSubmit () {
      this.submitForm = !this.submitForm
    },

    renderPayload ({
      employee,
      costCenters,
      useRideCredit,
      credit,
      recurrenceCredit = 0,
      useRidePeriod = 'UNTIL_REACH',
      useBudget,
      budget
    }) {
      return {
        enabled: employee.enabled && employee.status === 'enabled',
        form: {
          id: employee.id,
          employee: {
            name: employee.name,
            email: employee.email,
            phoneCountry: employee.phoneCountry,
            phone: employee.phone,
            nationalId: employee.nationalId,
            externalId: employee.externalId,
            v2Permission: employee.v2Permission,
            webCallPermission: employee.webCallPermission,
            thirdPartyWebCallPermission: employee.thirdPartyWebCallPermission,
            categoryIds: employee.categoryIds,
            companyId: employee.companyId,
            supervisorId: employee.supervisorId,
            budgetLimit: budget && budget.budgetCurrency ? budget.budgetCurrency : employee.budgetLimit,
            usePin: employee.usePin,
            pin: employee.pin
          },
          costCenters: costCenters.map(item => item.id),
          useRideCredit,
          credit,
          recurrenceCredit,
          useRidePeriod,
          useBudget,
          budgetPeriod: budget && budget.period ? budget.period : null,
          budgetDate: budget && budget.date ? moment(budget.date).format('DD/MM/YYYY') : null,
          budgetCumulative: budget && budget.budgetCumulative && budget.budgetCumulative === 'true',
          budgetCurrency: budget && budget.budgetCurrency ? budget.budgetCurrency : null
        },
        company: employee.company,
        costCenters: costCenters,
        phone: employee.phone,
        supervisor: employee.supervisor
      }
    },

    setCurrentStatus (val) {
      if (val) this.currentStatus = val
    },

    setChatPosition (bottom = null, right = null) {
      const chat = document.querySelector('#oloswcdl-root .oloswebchat-main .cta-button')
      if (chat) {
        chat.style.bottom = bottom
        chat.style.right = right
      }
    },

    async getEmployeeById () {
      if (this.routeParams.type === 'editar') {
        this.currentStatus = STATUS_IS_LOADING

        try {
          const employeeId = Number(this.routeParams.id)
          const { data: res } = await this.$apiService.getEmployeeById(employeeId)
          this.employeeData = this.renderPayload(res.data)
          this.currentStatus = STATUS_SUCCESS
        } catch (err) {
          let message = null
          console.log('ERROR', err)
          this.currentStatus = STATUS_FAILED

          if (err && err.response && err.response.status !== 404) {
            message = this.$t(`${this.namespace}.employeeNotFoundMessage`)
            this.$router.push({ name: 'Employees' })
          } else {
            message = this.$t('Messages.genericError')
          }

          this.errorAlert(message)
        }
      }
    }
  },
  watch: {
    'routeParams.id' () {
      location.reload()
    }
  },
  beforeMount () {
    if (this.routeParams.type !== 'cadastrar' && this.routeParams.type !== 'editar') {
      this.$router.push({ name: 'Employees' })
    }
  },
  mounted () {
    this.getEmployeeById()

    if (this.routeParams.type !== 'editar') {
      this.currentStatus = STATUS_SUCCESS
    }

    this.setChatPosition('75px', '10px')
  },
  beforeDestroy () {
    this.setChatPosition()
  }
}
</script>
